// @ts-strict-ignore
import React from 'react'
import { RichText } from '../helpers/react'
import { Card } from '../../atoms'
import { removeWhitespaceAndSpecialChars } from '../helpers/commons'

const Chart = (props) => {
  const { title, contents, footnotes, chartConfig, name } = props

  const transposedContents = contents.map((_, colIndex) =>
    contents.map((_, rowIndex) => contents[rowIndex][colIndex]?.value),
  )

  const santisedArr = transposedContents
    .map((item) => item.filter((it) => !!it))
    .filter((arr) => arr.length > 0)

  const labels = santisedArr[0].slice(1)
  const datasets = santisedArr.slice(1)

  return (
    <div className='chart' id={removeWhitespaceAndSpecialChars(name)}>
      <Card variant={'modal'}>
        {title && <div className='chart__heading'>{title}</div>}
        {chartConfig.subHeading && (
          <div className='chart__sub-heading'>{chartConfig.subHeading}</div>
        )}
        <div
          className='chart__container'
          data-chart
          data-chart-labels={JSON.stringify(labels)}
          data-chart-dataset={JSON.stringify(datasets)}
          data-chart-config={JSON.stringify(chartConfig)}
        >
          <canvas data-chart-canvas id='myChart' height='405' />
        </div>
        {footnotes && (
          <div className='chart__footnotes'>
            <RichText content={footnotes} />
          </div>
        )}
      </Card>
    </div>
  )
}

export default Chart
